<template>
  <div>
    <Header :logged="logged" :home="false" />
    <div class="TextoServicos-container">
      <div class="sidebar-menu">
        <div class="card-menu">
            <div class="cardmenu-header" @click="expandServicosMenu">
              <span>Serviços</span>
            </div>
            <transition name="slide-fade">
              <div  v-if="expandMenu && mobile" class="cardmenu-body">
                <div class="cardmenu-line"><a @click="alterServico(servicos.envioTitulos)" >Envio de Títulos</a></div>
                <div class="cardmenu-line"><a @click="alterServico(servicos.autenticidadeProtesto)">Verificação de Autenticidade</a></div>
                <div class="cardmenu-line"><a @click="alterServico(servicos.pedidoCancelamento)" >Pedido de cancelamento</a></div>
                <div class="cardmenu-line"><a @click="alterServico(servicos.pedidoAnuencia)">Autorização de Cancelamento (Carta de anuência eletrônica)</a></div>
                <div class="cardmenu-line"><a @click="alterServico(servicos.pedidoCertidao)">Pedido de certidão</a></div>
              </div>      
            </transition>
            <div v-if="!mobile" class="cardmenu-body">
              <div class="cardmenu-line"><a @click="alterServico(servicos.envioTitulos)" >Envio de Títulos</a></div>
              <div class="cardmenu-line"><a @click="alterServico(servicos.autenticidadeProtesto)">Verificação de Autenticidade</a></div>
              <div class="cardmenu-line"><a @click="alterServico(servicos.pedidoCancelamento)" >Pedido de cancelamento</a></div>
              <div class="cardmenu-line"><a @click="alterServico(servicos.pedidoAnuencia)">Autorização de Cancelamento<br>(Carta de anuência eletrônica)</a></div>
              <div class="cardmenu-line"><a @click="alterServico(servicos.pedidoCertidao)">Pedido de certidão</a></div>
            </div>
        </div>
      </div>
      <div class="spinner d-flex" v-if="loading">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div> 
      <div class="innercontent-container" v-else>
        <div class="headline">
          <div class="headline-img"><img v-bind:src="getImgServico(servicoSelecionado.img)"></div>
          <!-- <div class="headline-img" @click="nextServico(servicoSelecionado.servico)"><img v-bind:src="getImgServico(servicoSelecionado.img)"></div> -->
          <div class="content-body">
            <div class="content-text">
            <!-- <div class="content-text" @click="nextServico(servicoSelecionado.servico)"> -->
              <h1>{{servicoSelecionado.titulo}}</h1>
              <p v-for="paragrafo in servicoSelecionado.texto" style="white-space: pre-line;">{{paragrafo}}</p>
            </div>
            <b-button :href="servicoSelecionado.btn.href" class="btn-servico " v-bind:class="servicoSelecionado.btn.class">{{servicoSelecionado.btn.texto}}</b-button>
          </div>
        </div>
        <!-- <tutoriaisrelacionados  :size="4" :tutorialTitle="true" :tutoriasCaller="false" :carousel="true"/> -->
      </div>
    </div>
      <footersite class="d-none d-xl-block" />
      <footersitemobile class="d-block d-xl-none"/>
  </div>
</template>

<script>
import Header from '../components/Header'
import footersite from "../components/footersite";
import footersitemobile from "../components/footersite/index_mobile";
import tutoriaisrelacionados from "../components/tutoriais_relacionados";
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';


export default {
  components: {
    Header,
    footersite,
    footersitemobile,
    tutoriaisrelacionados,
    BeatLoader,

  },
  data() {
    return {
      loading:false,
      logged:false,
      mobile: window.innerWidth < 1200,
      expandMenu: false,
      servicos: {
        envioTitulos: {
          servico:'envioTitulos',
          titulo: 'Envio de título para protesto',
          texto: [
            'O Protesto é o modo mais rápido e seguro para cobrança de dívidas, e agora está disponível de forma totalmente digital, para qualquer pessoa física ou jurídica, sem custos pelo apontamento*.', 
            'Basta preencher o formulário para encaminhar suas duplicatas, cheques, contratos e outras dívidas para cobrança em qualquer cidade do Brasil. O envio pode ser feito a partir do primeiro dia útil após o vencimento da dívida.',
            'Após o envio da dívida, o cartório correspondente ao domicílio do devedor o intimará para o pagamento da dívida no prazo de até 03 dias úteis. Caso ocorra o pagamento ao cartório dentro do prazo, o valor será repassado para a sua conta cadastrada.',
            'Caso a dívida não seja paga no prazo do cartório, ela será protestada, e a informação do protesto será enviada aos órgãos de restrição de crédito.',
            'Após o protesto, o devedor deverá regularizar sua dívida junto ao credor, que poderá então fornecer uma autorização de cancelamento, gratuitamente, por meio do menu "autorização de cancelamento". Caberá ao devedor concluir o cancelamento, realizando o pagamento das custas ao respectivo cartório.',
            '*Obs: desde o ano de 2019, não há mais cobrança de taxas de cartório do credor que envia títulos a protesto, para dívidas com menos de 01 ano do vencimento. Quem paga os custos do protesto é o devedor, ao pagar a dívida em cartório ou solicitar o cancelamento do protesto. A única hipótese de cobrança das custas do credor será em caso de pedido de desistência do protesto, ou seja, se após o envio decidir retirar a dívida antes da lavratura do protesto.'
          ],
          img: 'anuenciaConsulta.jpg',
          btn: {
            texto:'Protestar',
            class:'btn-grayblue',
            href:'/servico/envio-de-titulo',
          }
        },
        autenticidadeProtesto: {
          servico:'autenticidadeProtesto',
          titulo: 'Verificação de Autenticidade',
          texto: [
            'O verificador de autenticidade permite que os  instrumentos de protesto e certidões digitais, expedidos de forma eletrônica possam ter a sua autenticidade verificada de maneira segura, informando a a chave única localizada no documento.'
          ],
          img: 'co-workers-reviewing-reports-1.png',
          btn: {
            texto:'Consultar',
            class:'btn-blue',
            href:'/servico/autenticidade-protesto'
          }
        },
        pedidoCancelamento: {
          servico:'pedidoCancelamento',
          titulo: 'Pedido de cancelamento',
          texto: [
            'Se você negociou ou pagou alguma dívida protestada, mas ainda não cancelou o protesto no cartório, você poderá fazê-lo agora. Sem precisar ir ao cartório! Consulte seu documento, verifique os protestos que tem autorização para cancelamento, gere o pagamento online, Pague !'
          ],
          img: 'EXAME-MIDIA.png',
          btn: {
            texto:'Pedir cancelamento',
            class:'btn-blue',
            href:'/servico/pedido-cancelamento'
          }
        },
        pedidoAnuencia: {
          servico:'pedidoAnuencia',
          titulo: 'Autorização de Cancelamento (Carta de anuência eletrônica)',
          texto: [
            'Credor, você pode autorizar o cancelamento de protestos (anuência eletrônica).',
            'O credor poderá autorizar online o cancelamento de protesto, informando ao cartório que o devedor pagou a dívida e está autorizado a cancelar o protesto mediante o pagamento das despesas cartorárias.'
          ],
          img: 'TelaLogin.jpg',
          btn: {
            texto:'Pedir anuência',
            class:'btn-blue',
            href:'/servico/pedido-anuencia'
          }
        },
        pedidoCertidao: {
          servico:'pedidoCertidao',
          titulo: 'Pedido de certidão',
          texto: [
            `Você pode solicitar uma certidão de protesto para qualquer cartório do Brasil. Rápido, seguro e sem intermediários. Receba suas certidões digitais em até 5 dias úteis após a identificação do pagamento.
            A Certidão de protesto é um documento emitido pelo cartório em formato digital ou em papel, que informa a existência ou não de protesto em um CPF/CNPJ. A certidão pode ser:`,
            'Negativa - Informando que NÃO CONSTAM PROTESTOS no CPF/CNPJ pesquisado.',
            'Positiva - Informando que CONSTAM PROTESTOS no CPF/CNPJ pesquisado, e detalha as informações sobre o título e o credor. Sua abrangência pode ser de 5 ou 10 anos, dependendo da necessidade do interessado.',
            'A certidão de protesto normalmente é utilizada nas seguintes situações:',
            `•	Quando o devedor não tem conhecimento de quem o protestou;
            •	Compra e Venda de imóvel; 
            •	Financiamento; 
            •	A pedido da rede bancária. `,
          ],
          img: 'ESTADAO.png',
          btn: {
            texto:'Pedir certidão',
            class:'btn-grayblue',
            href:'/servico/pedido-certidao',
          }
        },
      },
      servicoSelecionado:{servico:'',titulo:'',texto:[],img:'',btn:{texto:'',class:'',href:''}},
      logged: false,
    }
  },
  beforeMount(){
    this.loading = true;
    this.servicoSelecionado = this.servicos.envioTitulos;
  },
  mounted() {
    this.$root.isLogged().then((res) => {
      this.logged = true;
      this.loading = false;
    }).catch((e) => {
      this.logged = false;
      this.loading = false;
    })
  },
  methods: {
    getImgServico(img) {
      if (img.includes('png')) 
        var images = require.context('../assets/imgs/', false, /\.png$/);
      else
        var images = require.context('../assets/imgs/', false, /\.jpg$/);
      return images('./' + img)
    },
    alterServico(servico){
      this.loading = true;
      this.servicoSelecionado = servico;
      this.expandMenu = false;
      setTimeout(() => {
        this.loading = false;
      }, 250);
    },
    nextServico(servico){
      var servicosKeys = Object.keys(this.servicos);
      var nextIndex = servicosKeys.indexOf(servico) + 1;
      nextIndex = (nextIndex >= servicosKeys.length ? 0 : nextIndex);
      this.servicoSelecionado = this.servicos[servicosKeys[nextIndex]];
    },
    expandServicosMenu(){
      if(this.mobile){
        this.expandMenu = !this.expandMenu;
      }
    },
  }
}
</script>

<style scoped>
.TextoServicos-container{display: flex;margin: 120px 4.1vw 37px 3.8vw;padding-top: 41px;padding-bottom: 95px;}
.TextoServicos-container .sidebar-menu {margin-right: calc(((100vw - 964px)/2 - 4.1vw - 293px));}
    .TextoServicos-container .sidebar-menu .card-menu {width: 293px;display: flex;flex-flow: column;box-shadow: #00000052 1px 2px 13px;}
      .TextoServicos-container .sidebar-menu .card-menu .cardmenu-header {display: flex;align-items: center;justify-content: center;height: 46px;background: var(--primary-color) 0% 0% no-repeat padding-box;}
        .TextoServicos-container .sidebar-menu .card-menu .cardmenu-header span {font: normal normal 400 20px/32px 'Kanit', sans-serif; letter-spacing: -1%;color: #FFFFFF;user-select: none; }
      .TextoServicos-container .sidebar-menu .card-menu .cardmenu-body {display: flex;flex-flow: column;width: inherit;background: #FFFFFF  0% 0% no-repeat padding-box;}
      .TextoServicos-container .sidebar-menu .card-menu .cardmenu-body .cardmenu-line {display: flex;flex-flow: column;align-items: center;width: inherit;}
        .TextoServicos-container .sidebar-menu .card-menu .cardmenu-body .cardmenu-line:not(:last-child):after {content: '';width: 267px;background-color: var(--secondary-color);height: 1px;}
        .TextoServicos-container .sidebar-menu .card-menu .cardmenu-body .cardmenu-line a{cursor:pointer;width: inherit;text-align: center;font: normal normal 200 16px/20px 'Kanit', sans-serif; letter-spacing: -1%;color: var(--secondary-color);padding: 16px 0;user-select: none;}
          .TextoServicos-container .sidebar-menu .card-menu .cardmenu-body .cardmenu-line a:hover{text-decoration: none;background: #A8A8A82D 0% 0% no-repeat padding-box;}
  .TextoServicos-container .innercontent-container{display: flex;flex-flow: column;}
    .TextoServicos-container .innercontent-container .headline{width: 100%;display: flex;min-height: 398px;margin-bottom: 47px;}
      .TextoServicos-container .innercontent-container .headline .headline-img{ flex: 1 1 41.5%;max-width: 41.5%;height: 100%;margin-right: 2.75%;user-select: none;}
        .TextoServicos-container .innercontent-container .headline .headline-img img{width: 100%;height: 100%;object-fit: cover;}
        .TextoServicos-container .innercontent-container .headline  .content-body{flex: 1 1 55.75%;max-width: 55.75%;display: flex;flex-flow: column;justify-content: space-between;}
        .TextoServicos-container .innercontent-container .headline .content-body .content-text{display: flex;flex-flow: column;}
          .TextoServicos-container .innercontent-container .headline .content-body .content-text h1{font: normal normal 200 42px/41px 'Kanit', sans-serif; letter-spacing: -1%;color: var(--primary-color);margin-bottom: 17px;}
          .TextoServicos-container .innercontent-container .headline .content-body .content-text p{font: normal normal 200 16px/20px 'Kanit', sans-serif ;letter-spacing: -1%;color: var(--secondary-color);margin-bottom: 20px;}
          .TextoServicos-container .innercontent-container .headline .content-body .content-text p:last-child{margin-bottom: 34px;}
          .TextoServicos-container .innercontent-container .headline .content-body .btn.btn-servico{width: fit-content;height: 49px;border-radius: 40px;border:none;font: normal normal 400 20px/20px 'Kanit', sans-serif; padding: 0 30px;display: flex;align-items: center;}
          .TextoServicos-container .innercontent-container .headline .content-body .btn.btn-servico.btn-grayblue{background: var(--primary-color) 0% 0% no-repeat padding-box;}
          .TextoServicos-container .innercontent-container .headline .content-body .btn.btn-servico.btn-blue{background: var(--primary-color) 0% 0% no-repeat padding-box;}
  
  @media (max-width: 1700px) and (min-width: 1500px) {
      .TextoServicos-container .sidebar-menu .card-menu{width: 15.26vw;}
          .TextoServicos-container .sidebar-menu .card-menu .cardmenu-body .cardmenu-line:not(:last-child):after {width: 13.9vw;}
  }
  @media (max-width: 1700px) and (min-width: 1601px) {
    .TextoServicos-container .sidebar-menu {margin-right: calc(((100vw - 964px)/2 - 4.1vw - 15.26vw));}
  }
  @media (max-width: 1600px) and (min-width: 1400px) {
    .TextoServicos-container{margin-left: 20px;margin-right: 20px;}
      .TextoServicos-container .sidebar-menu {margin-right: calc(((100vw - 964px)/2 - 20px - 15.26vw));}
      /* 293 267 */
  }
  @media (max-width: 1499px) and (min-width: 1200px) {
    .TextoServicos-container .sidebar-menu {margin-right: 59px;}
  }
  
  @media (max-width: 1399px) and (min-width: 1200px){
    .TextoServicos-container{margin-left: 10px;margin-right: 10px;}
  }
  @media (max-width:1199px){
    .TextoServicos-container{flex-flow: column;margin: 0;padding: 0;}
    .TextoServicos-container .sidebar-menu{margin: 0;position: absolute;width: 100%;background: white;z-index: 99;}
    .TextoServicos-container .sidebar-menu .card-menu{width: 100%;}
    .TextoServicos-container .sidebar-menu .card-menu .cardmenu-header{height: 48px;cursor: pointer;z-index: 100;}
    .TextoServicos-container .sidebar-menu .card-menu .cardmenu-header::before{content:'';position:absolute;top:calc(48px - 17px);z-index: 100;height: 27px;width: 27px;background-color: var(--primary-color);border-radius: 100%;}
    .TextoServicos-container .sidebar-menu .card-menu .cardmenu-header::after{content:'';position:absolute;top:calc(48px - 7px);z-index: 101;height: 8.5px;width: 8.5px;border-left: 2px solid white;border-bottom: 2px solid white;transform: rotate(-45deg);}
    .TextoServicos-container .sidebar-menu .card-menu .cardmenu-body {z-index: 0;}
    .TextoServicos-container .sidebar-menu .card-menu .cardmenu-body .cardmenu-line a{padding:14px 14px;}
    .TextoServicos-container .sidebar-menu .card-menu .cardmenu-body .cardmenu-line:not(:last-child):after{width: calc(100% - 28px);}

    .TextoServicos-container .innercontent-container{margin-top: 48px;}
    .TextoServicos-container .innercontent-container .headline{flex-flow: column;margin-bottom: 34px;}
    .TextoServicos-container .innercontent-container .headline .headline-img,
    .TextoServicos-container .innercontent-container .headline .content-body{width: 100%;flex: unset;max-width: unset;}
    .TextoServicos-container .innercontent-container .headline .content-body{padding:0 20px;margin-top: 26px;}
    .TextoServicos-container .innercontent-container .headline .content-body .content-text h1{margin-bottom: 15px;}
    .TextoServicos-container .innercontent-container .headline .content-body .content-text p:last-child{margin-bottom: 26px;}
    .TextoServicos-container .innercontent-container .headline .content-body .btn.btn-servico{width: 100%;}

    .slide-fade-enter-active {
      transition: transform .3s ease;
    }
    .slide-fade-leave-active {
      transition: transform .4s cubic-bezier(1.0, 0.5, 0.8, 1.0), opacity .8s ease;
    }
    .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active below version 2.1.8 */ {
      transform: translateY(-100%);
      opacity: 0;
    }
    .TextoServicos-container .sidebar-menu{background: none;}
    .TextoServicos-container .sidebar-menu .card-menu{box-shadow:none;}
    .TextoServicos-container .sidebar-menu .card-menu .cardmenu-body{background:white;box-shadow: #00000052 1px 2px 13px;}
    .TextoServicos-container .sidebar-menu .card-menu .cardmenu-body .cardmenu-line{background: #a8a8a826  0% 0% no-repeat padding-box}

    
}
.spinner {position: relative;width: 100%;height: 100%;display: flex;align-self: center;justify-content: center;align-items: center;background: none;top: 0;left: 0;z-index: 100;}
.spinner-border{width: 200px;height: 200px;border: 17px solid var(--primary-color);border-right-color: var(--primary-color);border-right-color: transparent;}
</style>
